module.exports = __webpack_public_path__ + "static/media/ic_save_icon.74c113d6.svg";